import * as React from 'react';
const MapView = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18.846} height={13.735} {...props}>
    <path
      fill="#05ac9f"
      d="M5.446 2.048h12.587a.814.814 0 1 0 0-1.627H5.446a.814.814 0 1 0 0 1.627Zm0 5.632h12.587a.813.813 0 1 0 0-1.626H5.446a.813.813 0 1 0 0 1.626Zm0 5.633h12.587a.814.814 0 1 0 0-1.627H5.446a.814.814 0 1 0 0 1.627ZM1.234 2.469A1.236 1.236 0 0 0 2.111.363 1.186 1.186 0 0 0 1.234 0 1.24 1.24 0 0 0 0 1.235a1.233 1.233 0 0 0 1.234 1.234Zm0 5.632a1.235 1.235 0 1 0 0-2.469 1.235 1.235 0 1 0 0 2.469Zm0 5.633a1.235 1.235 0 1 0 0-2.47 1.235 1.235 0 0 0 0 2.47Z"
      data-name="Path 37118"
    />
  </svg>
);
export default MapView;
